import { ShowSnackBar } from "event-definitions"

export function snackbar(message, options = {}) {
    ShowSnackBar.raiseLater(message, options)
}
